import React, { FC, ReactNode } from 'react';
import cn from 'classnames';
import st from './Button.module.css';

type ButtonProps = {
  children: ReactNode;
  className?: string;
  onClick: () => void;
  dataTestId?: string;
};

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className = [],
  dataTestId = '',
}) => (
  <button
    data-testid={dataTestId}
    className={cn(st.button, className)}
    type="button"
    onClick={onClick}
  >
    {children}
  </button>
);

export default Button;
